import React, { useState } from 'react';
import { 
    Container, 
    Typography, 
    Accordion, 
    AccordionSummary, 
    AccordionDetails, 
    Box, 
    useTheme,
    useMediaQuery} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';





const Faq = () => {
    const [expanded, setExpanded] = useState(false);
    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    const faqlist = [
        {
            question: 'What documents do I need to rent a property?',
            answer: 'Typically, you\'ll need a valid ID, proof of income (like pay stubs or tax returns), references from previous landlords, and sometimes a credit report. Some landlords might also require a security deposit.'
        },
        {
            question: 'How much is the security deposit usually?',
            answer: 'Security deposits usually range from one to three months\' rent, depending on the property and local regulations. This amount is refundable at the end of your tenancy, provided there are no damages beyond normal wear and tear.'
        },
        {
            question: 'What\'s included in the rent?',
            answer: 'This varies by property. Some rentals include utilities (water, gas, electricity) and amenities (gym, pool), while others don\'t. Always confirm what\'s included before signing a lease.'
        },
        {
            question: 'How long is the typical lease term?',
            answer: 'Most residential leases are for 12 months, but some landlords offer shorter (3-6 months) or longer (18-24 months) terms. Short-term rentals might have different terms and higher rates.'
        },
        {
            question: 'What happens if I need to break my lease early?',
            answer: 'Breaking a lease early typically requires paying a fee (often 1-2 months\' rent) or finding a new qualified tenant. Some leases have specific early termination clauses, so review your contract carefully.'
        },
        {
            question: 'Are pets allowed in rental properties?',
            answer: 'This depends on the landlord\'s policy. Some properties allow pets with an additional pet deposit or monthly fee, while others have strict no-pet policies. Service animals are typically exempt from these restrictions.'
        },
        {
            question: 'How often can the rent be increased?',
            answer: 'Rent increases are typically limited to once per year for month-to-month tenancies after the initial lease term. The specific rules vary by location, so check your local tenancy laws.'
        },
        {
            question: 'What\'s the difference between a rental application and a lease agreement?',
            answer: 'A rental application is used to screen potential tenants, while a lease agreement is the actual contract that outlines the terms of tenancy. The application typically comes first in the rental process.'
        }
    ];

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Container maxWidth="lg" sx={{ py: isMobile ? 4 : 6, minHeight: '80vh' ,mt:14}}>
            <Typography 
                variant="h3" 
                sx={{
                    fontSize: isMobile ? '24px' : '32px',
                    fontWeight: 600,
                    mb: 4,
                    color: theme.palette.primary.main,
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                }}
            >
                Frequently Asked Questions
            </Typography>
            
            <Box sx={{ maxWidth: 800, mx: 'auto' }}>
                {faqlist.map((faq, index) => {
                    const isOpen = expanded === `panel${index}`;
                    return (
                        <Accordion 
                            key={index} 
                            expanded={isOpen} 
                            onChange={handleChange(`panel${index}`)}
                            sx={{
                                mb: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                borderRadius: 2,
                                '&:before': { display: 'none' },
                                '&.Mui-expanded': {
                                    margin: '16px 0',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.12)'
                                }
                            }}
                        >
                            <AccordionSummary
                                expandIcon={
                                    <ExpandMoreIcon 
                                        sx={{ 
                                            color: isOpen ? theme.palette.primary.main : 'inherit',
                                            transform: isOpen ? 'rotate(360deg)' : 'none',
                                            transition: 'transform 0.3s, color 0.3s'
                                        }} 
                                    />
                                }
                                sx={{
                                    minHeight: 64,
                                    '&.Mui-expanded': {
                                        minHeight: 64,
                                        backgroundColor: theme.palette.background.paper,
                                        borderBottom: isOpen ? `1px solid ${theme.palette.divider}` : 'none'
                                    },
                                    '& .MuiAccordionSummary-content': {
                                        my: 1,
                                        '&.Mui-expanded': {
                                            my: 1
                                        }
                                    }
                                }}
                            >
                                <Typography 
                                    variant="subtitle1" 
                                    sx={{
                                        fontWeight: isOpen ? 600 : 500,
                                        color: isOpen ? theme.palette.primary.main : 'text.primary',
                                        fontSize: isMobile ? '0.9rem' : '1rem',
                                        transition: 'color 0.2s'
                                    }}
                                >
                                    {faq.question}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    backgroundColor: theme.palette.background.paper,
                                    borderBottomLeftRadius: 8,
                                    borderBottomRightRadius: 8,
                                    px: isMobile ? 2 : 3,
                                    py: 2.5
                                }}
                            >
                                <Typography 
                                    variant="body1" 
                                    sx={{
                                        color: 'text.secondary',
                                        lineHeight: 1.7,
                                        fontSize: isMobile ? '0.9rem' : '1rem'
                                    }}
                                >
                                    {faq.answer}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    );
                })}
            </Box>
        </Container>
    );
};

export default Faq;